export default "__VITE_ASSET__BYbEHTJR__"